
import { SiriusBaseComponent } from 'sirius-framework';
import { Component, Input } from '@angular/core';
import { NodeMenuModel } from '../../models/tree-menu.model';

@Component({
  selector: 'tree-menu',
  templateUrl: './tree-menu.component.html',
  styleUrls: ['./tree-menu.component.css']
})
export class TreeMenuComponent extends SiriusBaseComponent<any> {    
    @Input("Tree") tree: NodeMenuModel[];
    @Input("ImageSrc") imageSrc: string;
    @Input("CurrentUrl") currentUrl: string;
    @Input("Level") level = 0;
    OnInit() { }
    goMenu(item: NodeMenuModel) {
        this.startTransaction(item.Transaction);
    }
    showChild(item: NodeMenuModel) {
        if (this.currentUrl.includes(item.Url))
            return true;
        return false;
    }
}
